enum CompanyStatus {
  ACTIVE,
  DISCONTINUED,
  IN_FORMATION,
}

export default CompanyStatus;
